var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71.75px",
    height: "105.625px",
    viewBox: "0 0 71.75 105.625",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "microphone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "microphone",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,51.875 C0,71.5 12.875,85.1875 31.625,87 L31.625,97.1875 L14,97.1875 C11.625,97.1875 9.75,99.0625 9.75,101.375 C9.75,103.75 11.625,105.625 14,105.625 L57.75,105.625 C60.0625,105.625 61.9375,103.75 61.9375,101.375 C61.9375,99.0625 60.0625,97.1875 57.75,97.1875 L40.0625,97.1875 L40.0625,87 C58.875,85.1875 71.75,71.5 71.75,51.875 L71.75,41.75 C71.75,39.375 69.875,37.5 67.5,37.5 C65.1875,37.5 63.3125,39.375 63.3125,41.75 L63.3125,51.5 C63.3125,68.3125 52.5,79.375 35.875,79.375 C19.25,79.375 8.4375,68.3125 8.4375,51.5 L8.4375,41.75 C8.4375,39.375 6.5625,37.5 4.1875,37.5 C1.875,37.5 0,39.375 0,41.75 L0,51.875 Z M17.4375,50.1875 C17.4375,61.9375 25,70 35.875,70 C46.6875,70 54.3125,61.9375 54.3125,50.1875 L54.3125,19.8125 C54.3125,8.0625 46.6875,0 35.875,0 C25,0 17.4375,8.0625 17.4375,19.8125 L17.4375,50.1875 Z M25.875,50.1875 L25.875,19.8125 C25.875,12.625 29.875,8.3125 35.875,8.3125 C41.8125,8.3125 45.875,12.625 45.875,19.8125 L45.875,50.1875 C45.875,57.375 41.8125,61.6875 35.875,61.6875 C29.875,61.6875 25.875,57.375 25.875,50.1875 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.a5215496ad333088717baaddd630dbc8.svg";
export { ForwardRef as ReactComponent };